import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'

import config from './js/config.js'

import '@/assets/iconfont/iconfont.css'
import '@/assets/iconfont/iconfont.js'

import './filters'
import './components'
// 三方组件
import vdiStPicker from 'v-distpicker'

import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/main.css'

import contactUs from '@/components/contactUs/index.vue'

Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.prototype.CONFIG = config
Vue.component('v-distpicker', vdiStPicker)
Vue.component('ContactUs', contactUs)
Vue.prototype.NODE_ENV = process.env.NODE_ENV
Vue.prototype.HOME_JCX_URL = process.env.HOME_JCX_URL
Vue.prototype.JJW_URL = process.env.JJW_URL
Vue.prototype.HOME_PAGE_URL = process.env.HOME_PAGE_URL
Vue.prototype.HOME_ABOUT_PAGE_URL = process.env.HOME_ABOUT_PAGE_URL
Vue.prototype.SSO_PAGE_URL = process.env.SSO_PAGE_URL
Vue.prototype.SP_PAGE_URL = process.env.SP_PAGE_URL
Vue.prototype.PU_PAGE_URL = process.env.PU_PAGE_URL
Vue.prototype.MALL_PAGE_URL = process.env.MALL_PAGE_URL
Vue.prototype.HOME_JCX_URL5 = process.env.HOME_JCX_URL5

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js